import { AttributesMixin, define } from "@type-r/models";
import { CountsModel } from "./countsModel";
import { restfulIO } from "./endpoint";

export interface RemittanceAdviceCount extends AttributesMixin<typeof RemittanceAdviceCount> { }
@define
export class RemittanceAdviceCount extends CountsModel {
    static endpoint = restfulIO('api/v1/ingest/remittance-advices/counts');

    static attributes = {
        ...CountsModel.attributes
    };

}
